import HTTP from '../HTTP';

const URL_BASE = 'gescom/Reglement/';

export async function create(param) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', param);
  return response;
}

export async function update(param) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', param);
  return response;
}

export async function remove(id) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: id } });
  return response;
}

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: id } });
  return response;
}

export async function replanificationAsync(param) {
  const response = await HTTP.post(URL_BASE + 'ReplanificationAsync', param);
  return response;
}
